export function cropAndFormatItems<T>(
  cropper: (items: T[]) => T[],
  formatter: (item: T) => string,
  separator: string,
  items: T[]
) {
  const cropped = cropper(items);
  return `${cropped.map(formatter).join(separator)}${cropped.length < items.length ? '...' : ''}`;
}
